/**
 * Where an agent's identity lives in the platform.
 *
 * <h3>Why one module for one path</h3>
 *
 * Two surfaces send somebody to the same page. The v2 SPIFFE panel links there
 * from the legacy agent view, and the Protect wizard's Identity step points at
 * it in prose three times. Each had, or was about to get, its own copy of the
 * string. A rename in the route table would leave the other one pointing at
 * nothing, and the first thing to notice would be a tenant following the link.
 *
 * <h3>Why the id is escaped</h3>
 *
 * Agent ids are UUIDs today, so nothing in them needs escaping. That is a fact
 * about the current data, not a property of the function - and a path built by
 * concatenation is how an id that one day carries a slash becomes a different
 * route. The cost is one call per render of a link.
 */

/** The route as the application declares it. Matched by the test beside this. */
export const IDENTITY_AGENT_ROUTE = '/identity/agents/:agentId';

/**
 * The identity page for one agent, or null when there is no agent to build it
 * for. Null rather than a half-built path: a link to /identity/agents/ is a
 * link to the wrong page, and a control that goes nowhere is worse than no
 * control.
 */
export function identityAgentPath(agentId) {
  if (!agentId) return null;
  return IDENTITY_AGENT_ROUTE.replace(':agentId', encodeURIComponent(agentId));
}
